import axios from 'axios';

export type PriceBookCatalogData = {
	versionId: string;
	versionName: string;
	publishedAt: string;
	components: Record<string, unknown>;
	islandSkus: Record<string, unknown>;
	countertopSkus: Record<string, unknown>;
	accessories: Record<string, unknown>;
	promotions: Record<string, unknown>;
};

export type FetchPriceBookCatalogParams = {
	versionId: string,
	getToken: () => Promise<string>
};

// The five collections of one published version, in the shape the PriceBook constructor takes.
export const fetchPriceBookCatalog = async (params: FetchPriceBookCatalogParams): Promise<[PriceBookCatalogData | null, string | null]> => {
	const { versionId, getToken } = params;

	try {
		const token = await getToken();
		const response = await axios.get<PriceBookCatalogData>(
			`${import.meta.env.VITE_API_URL}/manage/price-books/${encodeURIComponent(versionId)}/catalog`,
			{ headers: { Authorization: `Bearer ${token}` } }
		);
		return [response.data, null];
	} catch {
		return [null, 'Failed to load the price book catalog'];
	}
};
